import React from 'react';
import PropTypes from 'prop-types';

import { FourNetsApi } from 'four-nets/api/api';
import { Site } from 'four-nets/site';

import { User, UserStore } from 'four-nets/user/user';
import { BazaarProfile } from 'four-nets/bazaar/bazaar';
import FetchData, { Props as FetchDataProps, Fetch, Render, Transform } from 'lib/fetch-data/fetch-data';

import { BazaarProfileStore } from 'four-nets/bazaar/bazaar';
import BazaarProfileView from 'four-nets/bazaar/profile/bazaar-profile-view';

import { BazaarProfileViewStyles } from './bazaar-profile-view.scss';

export interface Props {
    user: User | { username: string };
    shopInfoTitle: React.ReactNode;
    noShopInfo: React.ReactNode;
    hideEdit?: boolean;
    linkToProfile?: boolean;
    profileStyle?: Partial<BazaarProfileViewStyles>;
}

interface Data {
    bazaarProfile: BazaarProfile;
    bazaarProfileStore: BazaarProfileStore;
    user: User;
    styles?: BazaarProfileViewStyles;
    userStore: UserStore;
    shopInfoTitle: React.ReactNode;
    noShopInfo: React.ReactNode;
    hideEdit?: boolean;
}

interface FetchProps extends FetchDataProps<Data, Data>, Props {}

class BazaarProfileLoader extends React.PureComponent<Props> {
    static contextTypes = {
        api: PropTypes.instanceOf(FourNetsApi),
        site: PropTypes.instanceOf(Site),
        userStore: PropTypes.instanceOf(UserStore),
    };

    fetch: Fetch<Data, FetchProps> = (setData, props) => {
        const fetchData = this.createFetchData(props);

        return fetchData.bazaarProfileStore
            .loadUserProfile(props.user.username)
            .then((bazaarProfile: BazaarProfile) => {
                setData({ bazaarProfile, user: bazaarProfile.user, ...fetchData });
            });
    };

    createFetchData = (props: Props) => {
        const { api, userStore } = this.context;
        const { hideEdit, shopInfoTitle, noShopInfo } = props;

        return {
            hideEdit,
            shopInfoTitle,
            noShopInfo,
            bazaarProfileStore: new BazaarProfileStore({
                api,
                userStore,
            }),
            userStore,
        };
    };

    transform: Transform<Data, Data, FetchProps> = (data, props) => {
        const fetchData = this.createFetchData(props);
        const bazaarProfile = fetchData.bazaarProfileStore.onJSON({ json: data.bazaarProfile });

        const { hideEdit, shopInfoTitle, noShopInfo, bazaarProfileStore, userStore } = fetchData;
        return {
            bazaarProfile,
            user: bazaarProfile.user,
            hideEdit,
            shopInfoTitle,
            noShopInfo,
            userStore,
            bazaarProfileStore,
        };
    };

    renderFetch: Render<Data> = ({ loading, error, data }) =>
        data ? (
            <BazaarProfileView
                profileStyle={this.props.profileStyle}
                bazaarProfile={data.bazaarProfile}
                user={data.user}
                userStore={data.userStore}
                bazaarProfileStore={data.bazaarProfileStore}
                hideEdit={data.hideEdit}
                shopInfoTitle={data.shopInfoTitle}
                noShopInfo={data.noShopInfo}
                linkToProfile={this.props.linkToProfile}
            />
        ) : null;

    render() {
        return (
            <FetchData
                serializerKey={__filename}
                fetch={this.fetch}
                transform={this.transform}
                render={this.renderFetch}
                user={this.props.user}
                hideEdit={this.props.hideEdit}
                shopInfoTitle={this.props.shopInfoTitle}
                noShopInfo={this.props.noShopInfo}
            />
        );
    }
}

export default BazaarProfileLoader;
